export default __webpack_public_path__ + "images/03eb361d6e2b8fb05456ce272314dd0a-tennis_small.webp";